import { SystemResourceProvider } from 'slipstream-components';
import administrationIcon from '../../assets/icons/nav/icon_administration.svg';
import dashboardIcon from '../../assets/icons/nav/icon_dashboard.svg';
import monitorIcon from '../../assets/icons/nav/icon_monitor.svg';
import reportIcon from '../../assets/icons/nav/icon_report.svg';
import resourceIcon from '../../assets/icons/nav/icon_resource.svg';
import serviceIcon from '../../assets/icons/nav/icon_service.svg';
import tenantIcon from '../../assets/icons/nav/icon_tenant.svg';

import jobPendingIcon from '../../assets/icons/job/icon_job_pending_utility.svg';
import jobRunningIcon from '../../assets/icons/job/icon_job_running_utility.svg';
import jobScheduleIcon from '../../assets/icons/job/icon_job_schedule_utility.svg';

export default class DefaultResourceProvider extends SystemResourceProvider {
  private resourceMap = new Map<string, any>();
  private appResourceMap = new Map<string, any>();
  constructor() {
    super();
    this.resourceMap.set('icon_dashboard', dashboardIcon);
    this.resourceMap.set('icon_resource', resourceIcon);
    this.resourceMap.set('icon_monitor', monitorIcon);
    this.resourceMap.set('icon_configuration', serviceIcon);
    this.resourceMap.set('icon_tenant', tenantIcon);
    this.resourceMap.set('icon_report', reportIcon);
    this.resourceMap.set('icon_administration', administrationIcon);

    this.appResourceMap.set('icon_job_pending', jobPendingIcon);
    this.appResourceMap.set('icon_job_running', jobRunningIcon);
    this.appResourceMap.set('icon_job_schedule', jobScheduleIcon);
  }

  public getAppIcons() {
    return this.appResourceMap;
  }

  public getNavigationIcons() {
    return this.resourceMap;
  }
}
